import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const FAQS = [
  { q: "What is Tradrin?", a: "Tradrin is a professional trading simulator that lets you practice trading without risking real capital. You replay historical data bar by bar, place orders, and analyze your performance." },
  { q: "Is it free?", a: "Yes, Tradrin is 100% free. All features are accessible without a subscription or credit card." },
  { q: "What markets can I trade?", a: "You can import data for any market: Forex (EURUSD, GBPUSD...), indices (S&P500, DAX...), crypto (BTC, ETH...), stocks, commodities. Just upload a CSV file with OHLCV data." },
  { q: "How does replay work?", a: "Replay reveals candles one by one, as if the market is advancing in real time. You can adjust the speed (1x to 50x), fast forward or rewind, and place orders at any time." },
  { q: "What indicators are available?", a: "47 technical indicators: RSI, MACD, Bollinger Bands, Ichimoku, Supertrend, ADX, Stochastic, VWAP, Volume Profile, Market Profile and many more. You can also create your own formulas." },
  { q: "What is the Prop Firm Challenge?", a: "It's a simulation of prop firm challenges like FTMO. You must follow drawdown rules and reach a profit target, just like a real challenge. Perfect for practicing before taking the real one." },
  { q: "How does the Strategy Tester work?", a: "The Strategy Tester lets you define entry/exit rules (e.g., SMA 9 crosses SMA 21) and test them automatically on all historical data. You instantly get the stats: win rate, profit factor, max drawdown, equity curve." },
  { q: "Is my data saved?", a: "Yes, everything is saved automatically: your sessions, trades, drawings, indicators, and replay progress. You can resume at any time." },
  { q: "Can I use Tradrin on mobile?", a: "Tradrin is optimized for desktop and tablet. The interface adapts to smaller screens, but for optimal trading experience, a large screen is recommended." },
  { q: "How do I import my data?", a: "Go to the Import page, upload a CSV file with columns: timestamp, open, high, low, close, volume. Tradrin automatically detects the format and timeframe." },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'faq-open' : ''}`} onClick={() => setOpen(v => !v)}>
      <div className="faq-question">
        <span>{q}</span>
        <span className="faq-chevron">{open ? '−' : '+'}</span>
      </div>
      {open && <div className="faq-answer">{a}</div>}
    </div>
  );
}

export default function FAQPage() {
  return (
    <>
      <Helmet>
        <title>FAQ — Tradrin Trading Simulator</title>
        <meta name="description" content="Frequently asked questions about Tradrin, the professional trading simulator. How it works, markets, indicators, Prop Firm Challenge." />
        <link rel="canonical" href="https://tradrin.com/faq" />
      </Helmet>
      <div className="landing">
        <nav className="landing-nav">
          <Link to="/" className="landing-logo">Tradrin</Link>
          <div className="landing-nav-links">
            <Link to="/">Home</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/login" className="landing-nav-login">Sign In</Link>
          </div>
        </nav>
        <div className="faq-page">
          <h1>Frequently Asked Questions</h1>
          <p className="faq-subtitle">Everything you need to know about Tradrin</p>
          <div className="faq-list">
            {FAQS.map((f, i) => <FAQItem key={i} q={f.q} a={f.a} />)}
          </div>
        </div>
        <footer className="landing-footer">
          <div className="landing-footer-bottom">
            <span>&copy; {new Date().getFullYear()} Tradrin. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </>
  );
}
